import { useSelector } from 'react-redux';
import { getLoggedInUserId } from 'selectors/loggedInUser';
import { useLocalStorage, useSessionStorage } from '@xmatters/react';

// TODO: remove this by updating all references in the repo to point to monorepo:
export {
  useLocalStorage,
  useSessionStorage,
  useStickyLocalStorage,
} from '@xmatters/react';
export default useLocalStorage;

export function useUserLocalStorage(key, ...rest) {
  const loggedInUserId = useSelector(getLoggedInUserId);
  return useLocalStorage(`${key}__${loggedInUserId}`, ...rest);
}

export function useUserSessionStorage(key, ...rest) {
  const loggedInUserId = useSelector(getLoggedInUserId);
  return useSessionStorage(`${key}__${loggedInUserId}`, ...rest);
}
